import * as React from 'react';
import { classNames, ComponentClassName, classNameModifierByFlag } from '@aws-amplify/ui';
import { View } from '../View/View.mjs';
import { primitiveWithForwardRef } from '../utils/primitiveWithForwardRef.mjs';
import { TabsContext } from './TabsContext.mjs';

const TabPanelPrimitive = ({ className, value, children, role = 'tabpanel', ...rest }, ref) => {
    const { activeTab, isLazy } = React.useContext(TabsContext);
    if (isLazy && activeTab !== value)
        return null;
    return (React.createElement(View, { ...rest, role: role, id: `${value}-panel`, "aria-labelledby": `${value}-tab`, className: classNames(ComponentClassName.TabsPanel, classNameModifierByFlag(ComponentClassName.TabsPanel, 'active', activeTab === value), className), ref: ref }, children));
};
/**
 * [📖 Docs](https://ui.docs.amplify.aws/react/components/tabs)
 */
const TabPanel = primitiveWithForwardRef(TabPanelPrimitive);
TabPanel.displayName = 'Tabs.Panel';

export { TabPanel };
